import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";

import Layout from "./components/layout/layout";
import Landing from "./components/home/landing";
import Butterflyventure from "./components/home/butterflyventure";
import LifeAtButterfly from "./components/home/lifeatbutterfly";
import Testimonial from "./components/home/testimonial";
import ImpactSection from "./components/home/impactsection";
import About from "./components/about/butterflygroups";
import Founder from "./components/about/founder";
import Journey from "./components/about/journey";
import Award from "./components/about/award";
import WellnessLanding from "./components/wellness/welnesslanding";
import WelnessAboutUs from "./components/wellness/welnessaboutus";
import WhoWeHelp from "./components/wellness/whowehelp";
import SignatureTherapies from "./components/wellness/signaturetherapies";
import WelnessTestimonials from "./components/wellness/welnesstestimonials";
import ConnectWithUs from "./components/wellness/connectwithus";
import ContactUs from "./components/contactus/contactus";
import { FaWhatsapp } from "react-icons/fa";
import PurePower from "./components/PurePower/purepower";
import PurePowerResidential from "./components/PurePower/Residential/PurePowerResidential";
import PurePowerCommercial from "./components/PurePower/Commercial/PurePowerCommercial";
import PurePowerGrid from "./components/PurePower/Grid/PurePowerGrid";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {/* Home Page */}
        <Route
          path="/"
          element={
            <Layout>
              <Landing />
              <Butterflyventure />
              <LifeAtButterfly />
              <Testimonial />
              <ImpactSection />
            </Layout>
          }
        />

        {/* About Page */}
        <Route
          path="/about"
          element={
            <Layout>
              <About />
              <Founder />
              <Journey />
              <Award />
            </Layout>
          }
        />

        {/* Wellness Page */}
        <Route
          path="/wellness"
          element={
            <Layout>
              <WellnessLanding />
              <WelnessAboutUs />
              <WhoWeHelp />
              <SignatureTherapies />
              <WelnessTestimonials />
              <ConnectWithUs />
            </Layout>
          }
        />

        {/* PuRE Power Page */}
        <Route
          path="/purepower"
          element={
            <Layout>
              <PurePower />
            </Layout>
          }
        />

        <Route
          path="/purepowerresidential"
          element={
          <Layout>
            <PurePowerResidential />
          </Layout>}
        />

        <Route
          path="/purepowercommercial"
          element={            
          <Layout>
            <PurePowerCommercial />
          </Layout>}
        />

        <Route
          path="/purepowergrid"
          element={
          <Layout>
            <PurePowerGrid />
          </Layout>}
        />

        {/* Contact Us Page */}
        <Route
          path="/contact"
          element={
            <Layout>
              <ContactUs />
            </Layout>
          }
        />

        {/* Redirect unknown routes */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <a
        href="https://wa.me/916235958246"
        className="fixed bottom-5 right-5 bg-green-500 text-white rounded-full p-2 shadow-lg hover:bg-green-600 transform hover:scale-110 transition duration-300 ease-in-out z-50"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaWhatsapp size={28} />
      </a>

    </Router>
  );
}

export default App;
